import ctl from '@netlify/classnames-template-literals';

const authButtonStyle = ctl(`
  text-lg
  text-white 
  bg-transparent
  cursor-pointer 
`);

export const buttonClasses = {
  text: 'font-normal',
  container: authButtonStyle,
};
